var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon67978(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n      .cls-1,\n      .cls-2,\n      .cls-3 {\n        stroke-width: 0px;\n      }\n      .cls-2 {\n        fill: #814196;\n      }\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m20.14,67.98v16.87c0,1.28.76,2.44,1.95,2.93s2.54.22,3.45-.69l5.48-5.48c11.54,11.4,30.14,11.36,41.62-.13,3.22-3.22,5.55-7,6.97-11.03.78-2.2-.38-4.6-2.57-5.38s-4.6.38-5.38,2.57c-1.01,2.87-2.66,5.57-4.98,7.88-8.2,8.2-21.44,8.24-29.69.13l5.42-5.43c.91-.91,1.17-2.27.69-3.45s-1.65-1.95-2.93-1.95h-16.87c-1.75,0-3.16,1.41-3.16,3.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.55,
    y: 54.84,
    width: 42.91,
    height: 7.05,
    rx: 3.52,
    ry: 3.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.86,6.45h-27.72c-4.04-.32-10.28,4.63-10.39,10.39v18.96h48.51v-18.96c0-5.74-4.66-10.39-10.39-10.39Zm-22.03,25.1c0,.61-.44,1.1-.99,1.1h-10.93c-.54,0-.99-.49-.99-1.1v-8.13c0-1.66,1.42-6.46,6.45-6.46s6.45,4.8,6.45,6.46v8.13Zm14.76-.11c0,.61-.44,1.1-.99,1.1h-10.93c-.54,0-.99-.49-.99-1.1v-8.13c0-1.66,1.42-6.46,6.45-6.46s6.45,4.8,6.45,6.46v8.13Zm14.88,0c0,.61-.44,1.1-.99,1.1h-10.93c-.54,0-.99-.49-.99-1.1v-8.13c0-1.66,1.42-6.46,6.45-6.46s6.45,4.8,6.45,6.46v8.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.1,38.81h-3.44c-2.3,0-4.16,1.86-4.16,4.16v5.74c0,2.3,1.86,4.16,4.16,4.16h3.44c2.3,0,4.16-1.86,4.16-4.16v-5.74c0-2.3-1.86-4.16-4.16-4.16Zm-1.72,9.2c-1.85,0-3.34-1.5-3.34-3.34s1.5-3.34,3.34-3.34,3.34,1.5,3.34,3.34-1.5,3.34-3.34,3.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.5,
    cy: 44.67,
    r: 3.46,
    transform: "translate(-20.9 38.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 63.86,
    cy: 44.56,
    r: 3.46,
    transform: "translate(-12.81 58.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m25.75,36.85v7.71c0,5.2,3.81,9.5,8.78,10.27h30.94c4.98-.77,8.78-5.08,8.78-10.27v-7.71H25.75Zm10.75,11.28c-1.92,0-3.46-1.55-3.46-3.46s1.55-3.46,3.46-3.46,3.46,1.55,3.46,3.46-1.55,3.46-3.46,3.46Zm19.77.58c0,2.3-1.86,4.16-4.16,4.16h-3.44c-2.3,0-4.16-1.86-4.16-4.16v-5.74c0-2.3,1.86-4.16,4.16-4.16h3.44c2.3,0,4.16,1.86,4.16,4.16v5.74Zm7.59-.69c-1.92,0-3.46-1.55-3.46-3.46s1.55-3.46,3.46-3.46,3.46,1.55,3.46,3.46-1.55,3.46-3.46,3.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.39,
    cy: 44.67,
    r: 3.34,
    transform: "translate(-8.92 12.77) rotate(-13.28)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon67978);
export default __webpack_public_path__ + "static/media/icon67978.15bd89ac9283c2426529ce3ac903b8bb.svg";
export { ForwardRef as ReactComponent };